import { defineStore } from 'pinia'
import {authApi} from "@/service/api";


export const useUserStore = defineStore('user', {
    state: () => {
        return {
            user: null,
            realUser: null,
            impersonatedAs: null,
            anonymous: false,
            darkMode: false,
            semester: 0,
            gitlabToken: '',
            originalMode: '',
            notifications: 0,
            hideSatisfiedNotifications: false,
            requestedHelpFilter: false,
            allowedShowFilter: false,
            solvedFilter: false,
            hiddenWeeks: {},
            hiddenSubjects: {},
            hiddenScoringRules: {},
            unfoldedLessons: [],
            lessonEditItemIds: {},
            moduleEditItemIds: {},
            requestText: '',
            locale: navigator.language === 'cs-CZ' ? 'customCs' : 'customEn'
        }
    },
    getters: {
        isLoggedIn: (state) => !!state.user,

        isAnyTeacher: (state) =>
            !!state.user &&
            state.user.isTeacher !== false &&
            (state.user.isTeacher === true ||
                (Array.isArray(state.user.isTeacher) && state.user.isTeacher.length > 0)),

        isTeacher: (state) => (course) =>
            !!state.user &&
            state.user.isTeacher !== false &&
            (state.user.isTeacher === true ||
                (Array.isArray(state.user.isTeacher) && state.user.isTeacher.includes(course.id))),

        isAdmin: (state) => !!state.user && !!state.user.isAdmin,

        isGuarantor: (state) =>
            !!state.user &&
            Array.isArray(state.user.isGuarantor) &&
            state.user.isGuarantor.length > 0,

        isImpersonated: (state) => state.impersonatedAs != null,
    },
    actions: {
        setUser(user) {
            this.user = user
            this.realUser = user
            this.gitlabToken = user?.gitlabToken ?? ''
        },
        setImpersonatedUser(userDto) {
            if (!this.realUser) this.realUser = this.user
            this.user = userDto
            this.impersonatedAs = userDto
        },

        clearImpersonation() {
            if (this.realUser) {
                this.user = this.realUser
                // this.realUser = null
                this.impersonatedAs = null
            }
            this.gitlabToken = this.user?.gitlabToken || "No gitlab token"
        },
        setNewGitlabToken(token) {
            this.gitlabToken = token
        },
        toggleAnonymous() {
            this.anonymous = !this.anonymous
        },
        toggleDarkMode() {
            this.darkMode = !this.darkMode
        },
        toggleLocale() {
            this.locale = this.locale === 'customCs' ? 'customEn' : 'customCs'
        },
        setNotifications(notifications) {
            this.notifications = notifications
        },
        async logout() {
            if (this.isImpersonated) {
                await authApi.revertImpersonation()
                this.clearImpersonation()
            }

            this.setUser(null)
        }
    },
    persist: true
})
